import React from "react";
import ToolCard from "../ToolCard";
import { SelectedToolsContainer } from "./SelectedTools.styled";

const SelectedTools = ({
  installedTools,
  onToggleTool,
  onSettings,
  onDelete,
}) => {
  return (
    <SelectedToolsContainer>
      {installedTools.map((tool) => (
        <ToolCard
          key={tool.id}
          title={tool.title}
          description={tool.description}
          icon={tool.icon}
          isEnabled={tool.isEnabled}
          onToggle={() => onToggleTool(tool.id)}
          onSettings={() => onSettings(tool)}
          onDelete={() => onDelete(tool.id)}
          toolData={tool}
          requiresSetup={tool.tag === "Requires configuration"}
        />
      ))}
    </SelectedToolsContainer>
  );
};

export default SelectedTools;

